import { ParentComponent, Show } from 'solid-js'
import { A, useLocation } from '@solidjs/router'
import { IconCard, IconCoin, IconBolt, IconUser, IconTrophy } from './Icons'
import { useBreakpoint } from './useBreakpoint'
import { userStore } from '/web/store'

const navItems = [
  {
    id: 'subs',
    label: 'Subscriptions',
    shortLabel: 'Subs',
    icon: IconCard,
    route: '/subscriptions',
  },
  {
    id: 'payments',
    label: 'Payment History',
    shortLabel: 'Payments',
    icon: IconCoin,
    route: '/payment-history',
  },
  {
    id: 'rewards',
    label: 'Rewards',
    shortLabel: 'Rewards',
    icon: IconTrophy,
    route: '/rewards',
  },
  { id: 'settings', label: 'Settings', shortLabel: 'Settings', icon: IconBolt, route: '/settings' },
]

const adminItems = [
  { id: 'admin-users', label: 'All Users', icon: IconUser, route: '/admin/users' },
  { id: 'admin-subs', label: 'All Subscriptions', icon: IconCard, route: '/admin/subs' },
  {
    id: 'admin-transactions',
    label: 'All Transactions',
    icon: IconCoin,
    route: '/admin/transactions',
  },
]

export const AccountLayout: ParentComponent = (props) => {
  const location = useLocation()
  const bp = useBreakpoint()
  const user = userStore()

  const isActive = (route: string) => location.pathname.startsWith(route)

  return (
    <div class="cf-acct-page">
      {/* Inner left nav */}
      <aside class="cf-acct-inner-nav">
        <div class="cf-acct-inner-nav-label">Account</div>
        {navItems.map((item) => (
          <A href={item.route} class={`cf-acct-inner-link ${isActive(item.route) ? 'active' : ''}`}>
            <item.icon size={18} />
            <span>{bp() === 'mobile' ? item.shortLabel : item.label}</span>
          </A>
        ))}

        {/* Admin section (desktop only — mobile reaches these via the slide-out menu) */}
        <Show when={user.user?.admin}>
          <div class="cf-acct-inner-admin">
            <div class="cf-acct-inner-nav-label">Admin</div>
            {adminItems.map((item) => (
              <A
                href={item.route}
                class={`cf-acct-inner-link ${isActive(item.route) ? 'active' : ''}`}
              >
                <item.icon size={18} />
                <span>{item.label}</span>
              </A>
            ))}
          </div>
        </Show>
      </aside>

      {/* Main content */}
      <main class="cf-acct-main">{props.children}</main>
    </div>
  )
}
